import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { IGetServiceProps } from "@api/types/globalService.types";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllNatureOfBusinessService = ({
  enableQuery,
  page = "1",
  per_page = "15",
}: IGetServiceProps) => {
  //States
  const [searchQuery, setSearchQuery] = useState("");
  //Hooks
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  //variables
  const created_between = urlQueries["created_between"] || "";

  const allNatureOfBusiness = useQuery({
    queryKey: [
      ...CACHE_KEYS.NATURE_OF_BUSINESS,
      debouncedQuery,
      page,
      per_page,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.NATURE_OF_BUSINESS,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[created_between]": created_between,
          page: page,
          per_page: per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allNatureOfBusiness },
    states: { searchQuery, setSearchQuery },
  };
};
